import { Link, Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { FleetCarLegend } from "commonComponents/CarDetails/CarDetailsStyled";
import CloseOutIcon from "assets/svgIcons/ModalCloseOutIcon";
import { ReactComponent as MarshalsCF } from "assets/svgIcons/MapLegendPopup/CarFilters/Marshals.svg";
import { ReactComponent as FbCF } from "assets/svgIcons/MapLegendPopup/CarFilters/F&B.svg";
import { ReactComponent as SpecialNeedsCF } from "assets/svgIcons/MapLegendPopup/CarFilters/SpecialNeeds.svg";
import NotCommunicating from "assets/svgIcons/NotCommunicating";
import { ReactComponent as NotInUseCF } from "assets/svgIcons/MapLegendPopup/ConnectedStates/NotInUse.svg";
import { ReactComponent as OutsideSitePerimetersCF } from "assets/svgIcons/MapLegendPopup/ConnectedStates/OutsideSitePerimeters.svg";
import { ReactComponent as Messages } from "assets/svgIcons/MapLegendPopup/ActionZonesFilters/Messages.svg";
import { ReactComponent as Control } from "assets/svgIcons/MapLegendPopup/ActionZonesFilters/Control.svg";
import { ReactComponent as CartPathOnly } from "assets/svgIcons/MapLegendPopup/ActionZonesFilters/Cart-pathOnly.svg";
import { ReactComponent as Geofence } from "assets/svgIcons/MapLegendPopup/ActionZonesFilters/Geofence.svg";
import { ReactComponent as OutOfService } from "assets/svgIcons/MapLegendPopup/Status/Outofservice.svg";
import { ReactComponent as CriticallyBehindPace } from "assets/svgIcons/MapLegendPopup/Pace/CriticallyBehindPace.svg";
import { ReactComponent as FallingBehindPace } from "assets/svgIcons/MapLegendPopup/Pace/FallingBehindPace.svg";
import { ReactComponent as LastReportedLocation } from "assets/svgIcons/MapLegendPopup/CarLocation/LastReportedLocation.svg";
import FbIcon from "assets/svgIcons/CarType/F&B";
import FleetCF from "assets/svgIcons/CarIcon";
import MarshalsIcon from "assets/svgIcons/CarType/Marshals";
import BatteryLowIcon from "assets/svgIcons/BatteryIcon";
import PaceIcon from "assets/svgIcons/MapLegendPopup/CarLocation/Pace";
import LocationCLIcon from "assets/svgIcons/MapLegendPopup/CarLocation/Location";
import PaceWiFi from "assets/svgIcons/MapLegendPopup/CarLocation/PaceWiFi";
import { mapHelpers } from "pages/Pins/utils/mapHelpers";
import { useTranslation } from "react-i18next";
import { uuid } from "_helperFunctions/uuid";
import { useSelector } from "react-redux";
import SpecialNeedsIcon from "assets/svgIcons/CarType/SpecialNeeds";
import ExclamationMarkIconWithBorder from "assets/svgIcons/ExclamationMarkWithRedBg";
import MembercarIcon from "assets/svgIcons/CarType/MembercarIcon";
import EnergySaverIcon from "assets/images/energy-saver.png";

const MapLegend = ({ handleClose2, open2 }) => {
  const { siteSettingsData } =
    useSelector((state) => state.commonReducers) || [];
  const { t } = useTranslation();
  const legendStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "912px",
    width: "100%",
    border: "none",
    background: "transparent",
    padding: "9px",
    outline: "none",
  };
  return (
    <Modal
      open={open2}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      onClose={handleClose2}
    >
      <Box sx={legendStyle}>
        <FleetCarLegend className="map-legend">
          <div className="modal-header">
            <h2>{t("Map_legend")}</h2>
            <button className="close-icon" onClick={handleClose2}>
              <CloseOutIcon />
            </button>
          </div>
          <div className="modal-body">
            <div className="first-section">
              <ul>
                <li className="li-main-heading">Navigation</li>
                <li className="li-sub-heading">{t("Car_Filters")}</li>
                <li>
                  <span>
                    <FleetCF color="#636F7C" width={20} />
                  </span>
                  {t("Fleet")}
                </li>
                <li>
                  <span>
                    <SpecialNeedsCF />
                  </span>
                  {t("Special_needs")}
                </li>
                <li>
                  <span>
                    <MarshalsCF />
                  </span>
                  {t("Marshal")}
                </li>
                <li>
                  <span>
                    <FbCF />
                  </span>
                  {t("F&B")}
                </li>
              </ul>
              <ul>
                <li className="li-main-heading"></li>
                <li className="li-sub-heading">{t("Connected_States")}</li>
                <li>
                  <span>
                    <NotInUseCF />
                  </span>
                  {t("NOT_in_use")}
                </li>
                <li>
                  <span>
                    <NotCommunicating color="#636F7C" />
                  </span>
                  {t("Not_communicating")}
                </li>
                <li>
                  <span>
                    <OutsideSitePerimetersCF />
                  </span>
                  {t("Cars_outside_site_perimeter")}
                </li>
                <li>
                  <span>
                    <img
                      src={EnergySaverIcon}
                      alt={t("Energy_Saver_Mode")}
                      style={{ width: "18px", height: "18px", objectFit: "contain", filter: "grayscale(100%) brightness(0.8)" }} />
                  </span>
                  {t("Energy_Saver_Mode")}
                </li>
              </ul>
              <ul>
                <li className="li-main-heading">Action Zones Filters</li>
                <li>
                  <span>
                    <Messages />
                  </span>
                  {t("Messages")}
                </li>
                <li>
                  <span>
                    <Control />
                  </span>
                  {t("Control")}
                </li>
                <li>
                  <span>
                    <CartPathOnly />
                  </span>
                  {t("Cart-path_Only")}
                </li>
                <li>
                  <span>
                    <Geofence />
                  </span>
                  {t("Geofence")}
                </li>
              </ul>
              <ul>
                <li className="li-main-heading">{t("Map")}</li>
                <li className="li-sub-heading">{t("Car_type")}</li>
                <li>
                  <span>
                    <MarshalsIcon />
                  </span>
                  {t("Marshal_car")}
                </li>
                <li>
                  <span>
                    <FbIcon />
                  </span>
                  {t("Food_&_beverage_car")}
                </li>
                <li>
                  <span>
                    <SpecialNeedsIcon />
                  </span>
                  {t("Special_needs_car")}
                </li>
                <li>
                  <span>
                    <MembercarIcon width={15} height={15} bg={"#00A000"} opacity={1} />
                  </span>
                  {t("Member_car")}
                </li>
                <li style={{ gap: 0 }}>
                  <span><MembercarIcon width={15} height={15} bg={"#00A000"} opacity={1} /> <SpecialNeedsIcon width={15} height={15} /></span>
                  {t("Member_/_Special_Needs")}
                </li>
                <li className="li-sub-heading">{t("Status")}</li>
                <li>
                  <span>
                    <ExclamationMarkIconWithBorder width={17} height={17} />
                  </span>
                  {t("Critical_fault_detected")}{" "}
                </li>
                <li>
                  <span>
                    <BatteryLowIcon
                      width="15.07px"
                      height="8.14"
                      color="#FFE500"
                    />
                  </span>
                  {t("Battery_warning")}{" "}
                </li>
                <li>
                  <span>
                    <BatteryLowIcon
                      width="15.07px"
                      height="8.14"
                      color="#FA3C30"
                    />
                  </span>
                  {t("Battery_critical")}{" "}
                </li>
                <li>
                  <span>
                    <OutOfService width={17} height={17} />
                  </span>
                  {t("Out_of_service")}
                </li>
              </ul>

              <ul>
                <li className="li-main-heading"></li>

                <li className="li-sub-heading">{t("Pace")}</li>
                <li style={{ gap: 6 }}>
                  <span>
                    <CriticallyBehindPace width={30} />
                  </span>
                  {t("Critically_behind_pace")}
                </li>
                <li style={{ gap: 6 }}>
                  <span>
                    <FallingBehindPace width={30} />
                  </span>
                  {t("Falling_behind_pace")}
                </li>
                <li className="li-sub-heading">{t("Courses")}</li>
                {siteSettingsData &&
                  siteSettingsData?.Courses &&
                  siteSettingsData?.Courses?.length !== 0 ? (
                  siteSettingsData?.Courses?.map((item) => (
                    <li key={() => uuid()}>
                      <span
                        className="number-icon"
                        style={{
                          background:
                            siteSettingsData &&
                            mapHelpers.CourseBGColor(
                              siteSettingsData,
                              item?.Number
                            ),
                          color:
                            siteSettingsData &&
                            mapHelpers.CourseTxtColor(
                              siteSettingsData,
                              item?.Number
                            ),
                        }}
                      >
                        {item?.Number}
                      </span>
                      {item?.Name}
                    </li>
                  ))
                ) : (
                  <></>
                )}
              </ul>
              <ul>
                <li className="li-main-heading"></li>
                <li className="li-sub-heading">{t("Car_Locations")}</li>
                <li>
                  <span>
                    <PaceIcon />
                  </span>
                  {t("On_pace,_in_RT")}
                </li>
                <li>
                  <span>
                    <PaceIcon color="#EAB52D" />
                  </span>
                  {t("Pace_warning,_in_RT")}
                </li>
                <li>
                  <span>
                    <PaceIcon color="#F01100" />
                  </span>
                  {t("Pace_critical,_in_RT")}
                </li>
                <li>
                  <span>
                    <PaceWiFi />
                  </span>
                  {t("On_pace,_in_Wi-Fi")}
                </li>
                <li>
                  <span>
                    <PaceWiFi color="#EAB52D" />
                  </span>
                  {t("Pace_warning,_in_Wi-Fi")}
                </li>
                <li>
                  <span>
                    <PaceWiFi color="#F01100" />
                  </span>
                  {t("Pace_critical,_in_Wi-Fi")}
                </li>
                <li style={{ gap: 6 }}>
                  <span>
                    <LastReportedLocation width={30}/>
                  </span>
                  {t("Last_Reported_Location")}
                </li>
                <li>
                  <span>
                    <LocationCLIcon />
                  </span>
                  {t("Starting_Location")}
                </li>
                <li>
                  <span>
                    <LocationCLIcon color="#00B400" />
                  </span>
                  {t("Ending_Location")}
                </li>
              </ul>
            </div>
          </div>
          <div className="modal-header">
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <Link
                href="https://help.visage.golf/visage-2/"
                underline="none"
                target="_blank"
              >
                {t("Visage_Help")}
              </Link>
              {"  "}
              {t("website")}
            </Typography>
          </div>
        </FleetCarLegend>
      </Box>
    </Modal>
  );
};

export default MapLegend;
